import { Charger, ChargerConnector } from "./charger";
import { SmartProfileSummary } from "./flexiCharging";
import { LocationInfo } from "./location";
import { PricingConditionModel } from "./pricingCondition";
import { UserModel } from "./user";
import { Car } from "./car";

export enum ChargingSessionState {
  Pending,
  InProgress,
  Parking,
  Finished,
  FailedToSetChargingProfile,
}

export enum PaymentStatus {
  FREE,
  PAID,
  UNPAID,
  ROAMING,
}

export enum PaymentInterval {
  INSTANT,
  MONTHLY,
  ROAMING,
}

export enum ChargingInitSources {
  SEAK,
  HUBJECT,
  VILLAPRO,
  PLUGNCHARGE,
  QVEND
}

export type ChargingSession = {
    id: string;
    startedAt: Date;
    endedAt: Date;
    startedParkingAt: Date;
    length: number;
    consumedWh: number;
    importedWh: number;
    offeredWh: number;
    price: number;
    user: UserModel;
    location: LocationInfo;
    charger: Charger;
    chargingConnector: ChargerConnector;
    chargingConnectorId: string;
    state: ChargingSessionState;
    hasInvoice: boolean;
    errorCause: string;
    idTag: string;
    paid: boolean;
    paymentInterval: PaymentInterval;
    pricingCondition: PricingConditionModel;
    whitelistAuthentication: boolean;
    chargerExternalId: string;
    connectorExternalId: number;
    paymentStatus: PaymentStatus;
    chargingPrice: number;
    parkingPrice: number;
    chargingInitSource: ChargingInitSources;
    smartProfile: SmartProfileSummary | null
    hjIdentificationValue: string;
    qVendQid: string | null;
    carId?: string | null;
    car?: Car | null;
    flexiChargingScheduleId?: string | null;
    flexiChargingSchedule?: any | null;
};
